<div class="no-padding fixed-scroll" >
  <div class="site_modal middleAlignBlock preferenceModal">
    <div class="middleAlign">
      <div class="no-padding site_modal--body site_modal--body-large">
        <div class="hidden-sm hidden-xs icon-cancel-svg" (click)="close()"></div>
        <div class="no-padding">
          <app-preference-center></app-preference-center>
        </div>
      </div>
    </div>
  </div>
</div>
